import React, {Component} from "react";
import Select from "react-select";

import {connect} from "react-redux";
import {fetchTags} from "../../../../store/slices/admin/tags";
import { DebouncedFunc, debounce, difference, isEqual } from "lodash";

type Props = {
	isEdit: boolean,
	brands: Array<string>,
	tags: Array<string>,
	cellId: number,
	type: string,
	id: number,
	updateConfig: Function,
	// injected
	dispatch: Function,
	isLoadingBrands: boolean,
	tagsData: Array<number>,
	isLoadingTags: boolean,
	isDisabled: boolean,
}

type OptionType = {
	value: string;
	label: string;
};

type State = {
	selectedTags:  OptionType[],
	tagSearch: string
}

class Tags extends Component<Props, State> {
	// used for passing additional tags on edit page that may not be present in new dataset when fetching current tags
	additionalTags: Array<string>;
	initTagsSet: boolean; 
	getTagOptions: DebouncedFunc<(inputValue: string) => void>;

	constructor(props: Props) {
		super(props);
		
		this.additionalTags = props.tags;
		this.initTagsSet = false;
		this.getTagOptions = debounce(this._getTagOptions, 400);

		this.state = {
			selectedTags: [],
			tagSearch: ''
		};

		this.onTagsChange = this.onTagsChange.bind(this);
	}

    static defaultProps = {
        isDisabled: false
    }

    componentDidMount() {
		const brands = this.props.brands.join(',');
		if (this.props.brands.length && this.props.tags && this.props.tags.length) {
			this.props.dispatch(fetchTags(brands, this.props.type, "", this.additionalTags, this.props.cellId));
		}
    }

    componentDidUpdate(prevProps: Props) {
		const brands = this.props.brands.join(',');
		if (!isEqual(prevProps.brands, this.props.brands)) {
			// this.props.dispatch(fetchTags(brands, this.props.type, this.additionalTags, this.props.cellId));

			if (prevProps.id === this.props.id && prevProps.brands.length > this.props.brands.length) {
				// If brand is removed, there is no need to fetch tags again, just delete tags for that brand
				const deletedBrands = difference(prevProps.brands, this.props.brands);

				this.setState((prevState, props) => {
					return { selectedTags: prevState.selectedTags && prevState.selectedTags.length ? prevState.selectedTags.filter(tagOption => !deletedBrands.includes(tagOption.value.split('-')[0])) : [] };
				}, () => {
					this.props.updateConfig(["tags"], [(!this.state.selectedTags || this.state.selectedTags.length < 1) ? [] : this.state.selectedTags.map(item => item.value)]);
				});
			} else {
				this.props.dispatch(fetchTags(brands, this.props.type, "", this.additionalTags, this.props.cellId));
			}
        }

		if ((!isEqual(prevProps.tagsData[this.props.cellId], this.props.tagsData[this.props.cellId]) || !isEqual(prevProps.tags, this.props.tags)) && !this.initTagsSet) {
			this.initTagsSet = true;
			this.setInitTags();
		}

		if (prevProps.type !== this.props.type) {
			this.additionalTags = [];
			this.setState({ selectedTags: [] }, () => {
				this.props.dispatch(fetchTags(brands, this.props.type, "", this.additionalTags, this.props.cellId));
			});
		}
    }

	_getTagOptions = (inputValue: string) => {
		if (this.props.brands.length > 0 && inputValue !== this.state.tagSearch) {
			this.setState({ tagSearch: inputValue });

			const brands = this.props.brands.join(',');
			this.props.dispatch(fetchTags(brands, this.props.type, inputValue, this.additionalTags, this.props.cellId));
		}
	};


	setInitTags() {
		const tags = this.props.tags;
		const tagsData = this.props.tagsData[this.props.cellId];
		let selectedTags: any[] = [];
		if (tagsData && tags && tags.length > 0) {
			this.props.brands.forEach((brand: string) => {
				// @ts-ignore
				if (tagsData && tagsData[brand] ) {
					// @ts-ignore
					selectedTags = [...selectedTags, ...tagsData[brand]];
					selectedTags = selectedTags.filter(item => tags.indexOf(item.value) !== -1);
				}
			});
		}

		this.setState({selectedTags});
	}

    getOptions() {
        let selectTags: any[] = [];
        const tagsData = this.props.tagsData[this.props.cellId];
        if (this.props.brands.length > 0) {
            this.props.brands.forEach(brand => {
				// @ts-ignore
                if (tagsData && tagsData[brand]) {
					// @ts-ignore
                    selectTags = [...selectTags, ...tagsData[brand]];
                }
            });
        } else {
			// @ts-ignore
            if (tagsData && tagsData.length > 0) {
                Object.getOwnPropertyNames(tagsData).forEach(brand => {
					// @ts-ignore
                    selectTags = [...selectTags, ...tagsData[brand]];
                });
            }
        }

		return selectTags;
    }

    onTagsChange(value: OptionType[]) {
		this.setState({selectedTags: value}, () => {
			this.props.updateConfig(["tags"], [(!value || value.length < 1) ? [] : value.map(item => item.value)]);
		});
    }

    filterTags(brands: Array<string>, tags: Array<string>,) {
		const tagsData = this.props.tagsData[this.props.cellId];
		let data: any[] = [];
		if (tagsData) {
			/* eslint-disable */
			Object.keys(tagsData).map(item => {
				if (brands.indexOf(item) !== -1) {
					// @ts-ignore
					if (tagsData[item].length > 0) {
						// @ts-ignore
						data.push(tagsData[item]);
					}
				}
			});
			/* eslint-disable */
			data = data.flat();

			return data.filter(item => tags.indexOf(item.value) !== -1);
		}

		return [];
	}

    render() {
        return (
			<div className="form-group">
				<label htmlFor="tags">Tags/Topics</label>
				<Select
					id="tags"
					className="basic-single"
					classNamePrefix="so-select-sort"
					isSearchable={true}
					isMulti
					value={this.state.selectedTags}
					options={this.getOptions()}
					onChange={(option) => this.onTagsChange((option as OptionType[]))}
					onInputChange={this.getTagOptions}
					closeMenuOnSelect={false}
					isLoading={this.props.isLoadingBrands || this.props.isLoadingTags}
					menuPortalTarget={document.body}
					styles={{menuPortal: base => ({...base, zIndex: 9999})}}
					isDisabled={this.props.isDisabled}
				/>
			</div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        isLoadingBrands: state.brands.isLoading,
        tagsData: state.tags.cellId ? state.tags.data : [],
        isLoadingTags: state.tags ? state.tags.isLoading : false
    }
};

export default connect(mapStateToProps)(Tags);